import { createRouter, createWebHistory } from 'vue-router'
import userRouter from './user'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/home-page.vue')
    },
    {
      ...userRouter,
    },
    {
      path: '/address',
      name: 'address',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/address/address-page.vue')
    },
    {
      path: '/audience',
      name: 'audience',
      component: () => import('@/views/audience/audience-page.vue')
    },
    {
      path: '/hot',
      name: 'hot',
      component: () => import('@/views/hot/hot-page.vue')
    },
    {
      path: '/system/user-center',
      name: 'user-center',
      component:  () => import('@/views/user-center/user-center.vue'),
    },
    {
      path: '/topic-activity/:topicId?',
      name: 'topic_activity',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/topic-activity/topic-activity-page.vue')
    },
    {
      path: '/list',
      name: 'list',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/list/list-page.vue')
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/views/orders/orders-page.vue')
    },
    // {
    //   path: '//order-detail/:orderId',
    //   name: 'orderDetail',
    //   component: () => import('@/views/order-detail/order-detail-page.vue')
    // },
    // {
    //   path: '/notice',
    //   name: 'notice',
    //   component: () => import('@/views/ticket-notice/ticket-notice.vue')
    // },
    // {
    //   path: '/support',
    //   name: 'support',
    //   component: () => import('@/views/support-center/support-center.vue')
    // },
    // {
    //   path: '/ticket-paid/:orderId',
    //   name: 'ticketPaid',
    //   component: () => import('@/views/ticket-paid/ticket-paid.vue')
    // },
    {
      path: '/:pathMatch(.*)*',
      component: () => import ('@/views/notFound.vue')
    },
  ]
});


export default router
